import { CheckboxOptionType, Col, Radio, Row } from "antd";
import { Key } from "react";
import styles from "./GridInputGroup.module.less";

export interface GridRadioGroupProps<T extends Key> {
  name: string;
  value: T;
  options: CheckboxOptionType<T>[];
  onChange: (value: T) => void;
  columns: number;
}

export const GridRadioGroup = <T extends Key, >({ name, value, options, onChange, columns }: GridRadioGroupProps<T>) => {
  return (
    <Radio.Group
      name={name}
      onChange={(e) => onChange(e.target.value)}
      value={value}
      style={{ width: "100%" }}
    >
      <Row>
        {options.map((option) => (
          <Col key={option.value} span={24 / columns}>
            <Radio key={option.value} value={option.value} className={styles.singleInput}>
              {option.label}
            </Radio>
          </Col>
        ))}
      </Row>
    </Radio.Group>
  );
};
